import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { FaChevronDown } from 'react-icons/fa';

const Header = () => (
  <Navbar
    className="mb-5 su-navbar font-weight-bold"
    sticky="top"
    expand="lg"
  >
    <Container>
      <Navbar.Brand href="https://www.scaleup.de">
        <img
          height="42"
          style={{ height: '42px' }}
          src="https://www.scaleup.de/wp-content/uploads/2022/03/scaleup-logo.svg"
          className="attachment-full size-full"
          alt=""
          loading="lazy"
        />
      </Navbar.Brand>
      <Navbar.Toggle
        className="bg-black"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse
        id="basic-navbar-nav"
        className="justify-content-center"
      >
        <Nav className="me-auto">
          <NavDropdown
            className="text-dark"
            title={[
              'Unsere Programme',
              <FaChevronDown className="ml-2" key="chevron" />,
            ]}
            id="programs-dropdown"
          >
            <NavDropdown.Item href="https://www.scaleup.de/programmuebersicht/">
              - Programmübersicht
            </NavDropdown.Item>
            <NavDropdown.Item href="https://www.scaleup.de/inhouse/">
              - Inhouse
            </NavDropdown.Item>
            <NavDropdown.Item href="https://www.scaleup.de/masterclass/">
              - MasterClass
            </NavDropdown.Item>
            <NavDropdown.Item href="https://www.scaleup.de/framework/">
              - Unser Framework
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Link href="https://www.scaleup.de/erfolgsgeschichten/">
            Erfolgsgeschichten
          </Nav.Link>
          <Nav.Link href="https://www.scaleup.de/team/">
            Über Uns
          </Nav.Link>
          <NavDropdown
            title={['Ressourcen', <FaChevronDown className="ml-2" key="chevron" />]}
            id="ressources-dropdown"
          >
            <NavDropdown.Item href="https://www.scaleup.de/ressourcen/#blog">
              - Blog
            </NavDropdown.Item>
            <NavDropdown.Item href="https://www.scaleup.de/ressourcen/#videos">
              - Videos
            </NavDropdown.Item>
            <NavDropdown.Item href="https://www.scaleup.de/ressourcen/#buecher">
              - Bücher
            </NavDropdown.Item>
            <NavDropdown.Item href="https://www.scaleup.de/ressourcen/#podcast">
              - Podcast
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Link
            className="nav-contact"
            href="https://www.scaleup.de/kontakt/"
          >
            <span>Kontakt</span>
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

export default Header;
